<template>
  <section
    class="page-plp_filter-side"
    :class="{
      'special-class': $route.name != 'plpSearch' && !isMobile,
      'special-class2': $route.name == 'plpSearch' && !isMobile
    }"
  >
    <nav-side
      v-if="categoryList.list && categoryList.list.length"
      ref="nav-side"
      :data="navList"
      :total-count="totalCount"
      :on-filter="onFilter"
      :filter-data="filterData"
      :reset-filter-data="resetFilterData"
      :params="params"
      :showTypeSide="showTypeSide"
      @onSelected="onSelected"
    ></nav-side>
  </section>
</template>
<script>
import { componentsCommon } from '@speedshop/template';
import { mapState } from 'vuex';
import navSide from './navSide.vue';
import { scrollToTop } from '@/utils/dom';
export default {
  components: {
    navSide
  },
  mixins: [componentsCommon],
  props: {
    totalCount: {},
    onFilter: {},
    filterData: {
      type: Array,
      default: () => []
    },
    resetFilterData: {},
    conditionKeyword: {},
    params: {},
    showTypeSide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timer: null,
      selectedData: {},
      sort: 'sort',
      visible: false,
      sortVisible: false,
      total: this.totalCount,
      SortMapping: {
        sort: { name: '默认', index: 0 },
        'onboardTime-0': { name: '最新', index: 1 },
        soldQty: { name: '热卖', index: 2 },
        'price-0': { name: '价格从低到高', index: 3 },
        'price-1': { name: '价格从高到低', index: 4 }
      }
    };
  },
  computed: {
    ...mapState(['headerList']),
    matchNavData() {
      const url = this.$route.path;
      const list =
        this.headerList.find(i => {
          const stringData = JSON.stringify(i);
          return stringData.includes(url);
        }) || {};
      return list;
    },
    breadcrumbData() {
      if (!this.matchNavData) {
        return {
          nav: [],
          breadcrumb: []
        };
      }
      const { children = [], navigationUrl } = this.matchNavData || {};
      const url = this.$route.path;
      if (url === navigationUrl) {
        return {
          nav: this.matchNavData,
          breadcrumb: [
            {
              name: '首页',
              path: '/'
            },
            {
              name: this.matchNavData.navigationName + '装备'
              // path: this.matchNavData.navigationUrl,
            }
          ]
        };
      } else {
        const secondData = children.find((item, index) => {
          const stringData = JSON.stringify(item);
          return index && stringData.includes(url);
        });
        if (!secondData) {
          return {
            nav: [],
            breadcrumb: []
          };
        }
        const { children: secondDataChildren = [], navigationUrl } = secondData || {};
        if (navigationUrl === url) {
          return {
            nav: [this.matchNavData, secondData],
            breadcrumb: [
              {
                name: '首页',
                path: '/'
              },
              {
                name: this.matchNavData.navigationName + '装备',
                path: this.matchNavData.navigationUrl
              },
              {
                name: this.matchNavData.navigationName + secondData.navigationName
                //  path: secondData.navigationUrl,
              }
            ]
          };
        } else {
          const thirdData =
            secondDataChildren.find(item => {
              const stringData = JSON.stringify(item);
              return stringData.includes(url);
            }) || {};
          return {
            nav: [this.matchNavData, secondData, thirdData],
            breadcrumb: [
              {
                name: '首页',
                path: '/'
              },
              {
                name: this.matchNavData.navigationName + '装备',
                path: this.matchNavData.navigationUrl
              },
              {
                name: this.matchNavData.navigationName + secondData.navigationName,
                path: secondData.navigationUrl
              },
              {
                name:
                  thirdData.navigationName &&
                  thirdData.navigationName.indexOf(this.matchNavData.navigationName) === 0
                    ? thirdData.navigationName
                    : this.matchNavData.navigationName + thirdData.navigationName
                //  path: thirdData.navigationUrl,

                //  path: thirdData.navigationUrl,
              }
            ]
          };
        }

        //
      }
    },
    breadcrumb() {
      return (this.breadcrumbData && this.breadcrumbData.breadcrumb) || [];
    },
    navList() {
      // 系列新品推荐不展示左侧导航；
      const navData = (this.matchNavData && this.matchNavData.children) || [];
      const FirstNav = navData[0] || '';
      const SecondNav = navData[1] || '';
      const url = this.$route.path;
      if (JSON.stringify(SecondNav).includes(url)) {
        return [];
      } else {
        const mainNav = navData.filter((item, index) => index > 1);
        return [...mainNav, SecondNav];
      }
    },
    sortList() {
      const data = (this.filterData && this.filterData.find(i => i.code === 'SORT')) || {};
      let { list } = data;
      if (list && list.length) {
        list = [
          { code: 'soldQty', value: { name: 'soldQty', sort: '1' } },
          { code: 'sort', value: { name: 'sort', sort: '0' } },
          ...list
        ]
          .filter(i => i.code !== 'onboardTime-1')
          .map(item => {
            return {
              ...item,
              name: this.SortMapping[item.code]?.name
            };
          });
        list.sort((a, b) => {
          return this.SortMapping[a.code].index > this.SortMapping[b.code].index ? 1 : -1;
        });
        return { ...data, list };
      } else {
        return [];
      }
    },
    categoryList() {
      const data = (this.filterData && this.filterData.find(i => i.code === 'CATEGORY')) || {};
      function findSecondLastChildrenWithChildren(tree) {
        const secondLastChildrenWithChildren = [];

        function traverse(node, depth) {
          if (!node.list || node.list.length === 0) {
            return;
          }
          const firstChild = node.list[0];

          if (firstChild.list && firstChild.list.length) {
            for (const child of node.list) {
              traverse(child, depth - 1);
            }
          } else {
            secondLastChildrenWithChildren.push(node);
          }

          // if (depth === 1) {
          //   secondLastChildrenWithChildren.push(node);
          //   return;
          // }

          // for (const child of node.list) {
          //   traverse(child, depth - 1);
          // }
        }

        for (const root of tree) {
          traverse(root, 2);
        }

        return secondLastChildrenWithChildren;
      }

      const { list = [], ...others } = data;

      const newList = list.map(item => {
        const children = item.children.map(i => {
          return {
            ...i,
            list: (i.list || i.children || []).map(e => {
              return {
                ...e,
                list: (e.list || e.children || []).map(c => {
                  return {
                    ...c,
                    list: c.list || c.children,
                    name: c?.name || c.categoryName
                  };
                }),
                name: e?.name || e.categoryName
              };
            }),
            name: i?.name || i.categoryName
          };
        });
        return {
          ...item,
          list: children,
          name: item?.name || item.categoryName
        };
      });
      const { categoryCode, categoryCodeList = [] } = this.params || {};
      const filterCategory = [categoryCode, ...categoryCodeList].filter(i => i);
      const secondLastChildrenWithChildren = findSecondLastChildrenWithChildren(newList);
      // 过滤categoryCode
      const filterNoMatchData = secondLastChildrenWithChildren;
      // const filterNoMatchData = !filterCategory.length
      //   ? secondLastChildrenWithChildren
      //   : secondLastChildrenWithChildren.filter(i => {
      //       const matchChildren = i.list.some(c => {
      //         const pathCodeList = c.categoryPath?.split('>') || [];
      //         return filterCategory.some(e => {
      //           return pathCodeList.includes(e);
      //         });
      //       });
      //       return matchChildren;
      //     });
      // 去重
      const myMap = new Map();
      filterNoMatchData.forEach(item => {
        const { name, list } = item;
        if (myMap.has(name)) {
          const data = myMap.get(name);
          list.forEach(i => {
            data.listMap.set(i?.name, i);
          });
          myMap.set(name, { ...data, list: newList });
        } else {
          const listMap = new Map();
          list.forEach(i => {
            listMap.set(i?.name, i);
          });
          myMap.set(name, { ...item, listMap });
        }
      });
      const newListMap = [...myMap.values()];
      const resultList = newListMap.map(i => {
        return {
          ...i,
          list: [...i.listMap.values()].map(item => {
            return {
              ...item,
              originalCode: item.categoryCode,
              categoryCode: item?.name,
              code: item?.name,
              attrCate: 'CATEGORY'
            };
          })
        };
      });
      return {
        ...others,
        list: resultList
      };
    }
  },
  watch: {
    totalCount(val, oldVal) {
      if (!oldVal) {
        this.total = val;
      }
    }
  },
  mounted() {
    // this.observeDOM();
  },

  beforeDestroy() {
    const container = document.querySelector('.sp-wrapper-scroll');
    if (container) {
      container.removeEventListener('scroll', this.listenerWidthThrottle, false);
    }

    // this.disconnectMutationObserver();
  },
  methods: {
    observeDOM() {
      // 创建一个观察者实例并传入回调函数
      const observer = new MutationObserver(mutation => {
        this.computedSideTop();
      });

      // 配置观察选项:
      const config = { attributes: true, childList: true, subtree: true };

      // 选择要观察变动的节点
      const targetNode = document.querySelector('#nuxt-app'); // 可以根据需要更改为更具体的父节点

      // 调用 observe 方法开始观察目标节点，以及观察变化类型
      observer.observe(targetNode, config);
    },
    computedSideTop() {
      // 尝试查询元素
      const elementExists = !!document.querySelector('.gt-layout-without-ad');
      // 检查元素是否存在 设置另一个元素的top样式
      const targetElement = document.querySelector('.sp-plp-page .page-plp-left');
      // if (!element) {
      //   if (targetElement) {
      //     targetElement.style.top = '100px';
      //   }
      // } else {
      //   targetElement.style.top = '66px';
      // }
      if (targetElement) {
        targetElement.style.top = elementExists ? '66px' : '100px';
      }
    },
    onChange(data, item) {
      const { parentCode: code } = data;
      if (item.type === 'CHECKBOX') {
        const checkedData = this.selectedData[code];
        if (checkedData) {
          const index = checkedData.findIndex(i => {
            return i.code === data.code;
          });
          index > -1 ? checkedData.splice(index, 1) : this.selectedData[code].push(data);
        } else {
          this.$set(this.selectedData, code, [data]);
        }
      } else {
        this.$set(this.selectedData, code, [data]);
      }
      this.onFilter(this.selectedData[code], item);
      this.backToTop();
    },
    onSortChange(code) {
      const data = this.sortList.list.find(i => i.code === code);
      this.onChange(data, this.sortList);
      this.sort = code;
      this.sortVisible = false;
    },
    changeTotalCount(data) {
      this.total = data;
    },
    backToTop() {
      // 回到顶部
      // const $scroll = document.querySelector('.sp-wrapper-scroll');
      // const adContainer = document.querySelector('.ad-page-top');
      // const adHeight = adContainer ? adContainer.offsetHeight : 0;
      // $scroll && $scroll.scrollTo(0, adHeight);
      // setTimeout(() => {
      //   // const leftContainer = document.querySelector('.page-plp_filter-side');
      //   const leftContainerParent = document.querySelector('.page-plp-left');
      //   // leftContainer.style.position = 'relative';
      //   // leftContainer.style.bottom = '0px';
      //   // leftContainer.style.top = '0px';
      //   // leftContainer.style.height = 'auto';
      //   // leftContainerParent.style.display = 'block';
      //   // leftContainerParent.style.height = 'auto';
      //   leftContainerParent.classList.remove('flex');
      //   leftContainerParent.classList.remove('fixed');
      //   leftContainerParent.classList.remove('sticky');
      //   leftContainerParent.classList.add('relative');
      //   leftContainerParent.style.height = 'auto';
      // }, 500);
      scrollToTop();
    },
    onSelected(val) {
      this.$emit('onSelected', val);
    }
  }
};
</script>
<style lang="scss">
.page-plp-left.flex {
  display: flex;
  flex-direction: column;
  height: auto;
  justify-content: flex-end;
  .page-plp_filter-side {
    position: relative;
  }
}
.page-plp-left.fixed {
  .page-plp_filter-side {
    position: fixed;
    bottom: 0px;
  }
}
.page-plp-left.sticky {
  .page-plp_filter-side {
    position: sticky;
    top: 50px;
  }
}
.page-layout_pc .sp-scroll-loading {
  overflow: visible !important;
}
.sp-plp-page.condition-product-list {
  padding-left: 0px !important;
  padding-right: 0px !important;
  max-width: 1440px;
  .gt-page-plp_skeleton_product {
    // width: calc(100% - 326px);
    // max-width: calc(100% - 326px);
  }
}
.sp-plp-page {
  width: 100%;
  max-width: 1440px !important;
  margin: 0px auto;
  padding: 0px 46px 0px 56px;
  .gt-page-plp_skeleton_product {
    flex-grow: 1;
    .sp-grid-list__wrapper {
      // grid-template-columns: repeat(3, 1fr) !important;
      // display: flex;
      // flex-wrap: wrap;
      // gap: 0px !important;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(calc(100% / 4), 1fr)) !important;
      grid-column-gap: 24px !important; /* 左右间距为24px */
      grid-row-gap: 32px !important; /* 上下间距为32px */
    }
  }
  .page-plp-left {
    min-width: 100% !important;
    max-width: 100% !important;
    // margin-right: 94px;
    position: sticky;
    // top: 66px;
    top: 100px;
    z-index: 99;
    background: white;
  }

  > div {
    .filter,
    .page-plp_filter-side {
      min-width: 100%;
      max-width: 100%;
      width: 100%;
      padding-top: 24px;
      padding-bottom: 24px;
      .page-search_title {
        color: var(--main-color-ua-dark-grey, #14141e);
        /* cn/pingfang/bold/32 */

        font-size: 32px;
        font-weight: 600;
        line-height: 38px; /* 118.75% */
      }
      .plp-top_breadcrumb {
        padding-top: 24px;

        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        width: 500px;
        max-width: 100vw;

        .el-breadcrumb__inner.is-link {
          color: #50505a;
        }
        .el-breadcrumb__item {
          &:last-child .el-breadcrumb__inner {
            color: #b4b4bf;
          }
        }
      }
    }
    .special-class {
      padding-bottom: 28px;
    }
    .special-class2 {
      padding-bottom: 32px;
    }
  }
}
.page-layout_pc {
  .sp-plp-page {
    > div {
      display: flex;
      flex-direction: column;
      // overflow: hidden;
    }
  }
}
.page-layout_mobile {
  .sp-plp-page.condition-product-list {
    // position: sticky;
    top: 0px;
    // z-index: 99;
    // min-height: 100vh;
  }
  .sp-plp-page {
    padding: 0px;
    > div {
      > div {
        &:first-child {
          position: sticky;
          top: 54px;
          z-index: 99;
        }
      }
      .page-plp_filter-side {
        padding-top: 0px;
        .plp-top_breadcrumb {
          padding-left: 12px;
          font-size: 12px;
          padding-top: 16px;
        }

        .mb-filter_tab {
          display: flex;
          line-height: 56px;
          border-bottom: 1px solid var(--border-color-default);
          width: 100vw;
          color: var(--font-color-primary);
          position: sticky;
          top: 0px;
          z-index: 103;
          .mb-filter_tab__item {
            flex-grow: 1;
            text-align: center;
            font-size: 12px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 50%;
            max-width: 50%;
            background: #fff;

            &:first-child {
              border-right: 1px solid var(--border-color-default);
            }
            i {
              margin-left: 16px;
              font-size: 14px;
            }
            .el-icon-arrow-down {
              transition: all 0.5s;
            }
            .rotate {
              transform: rotate(180deg);
            }
          }
        }
        .plp-ad {
          width: 100vw;
        }
        .el-drawer__wrapper.plp-sort_drawer {
          position: absolute;
          width: 100vw;
          top: 57px;
          z-index: 999;
          height: calc(100vh - 56px);
          .sort-list {
            padding: 24px;
            font-weight: 600;
            .sort-list_item {
              margin-bottom: 20px;
              color: var(--font-color-secondary);
              &.active {
                color: var(--font-color-primary);
                span {
                  border-bottom: 1px solid var(--font-color-primary);
                }
              }
            }
          }
        }
      }
    }

    .gt-page-plp_skeleton_product {
      padding-top: 0px !important;
      width: auto;
      max-width: 100%;
      .sp-grid-list__wrapper {
        .banner-item {
          max-width: 100% !important;
          width: 100% !important;
        }
        .waterfall__item {
          max-width: 50%;
          // margin: 0px auto;
          min-width: 50%;
          &:nth-child(odd) {
            border-right: 0.5px solid #f7f7f7; //白边
          }
          &:nth-child(even) {
            border-left: 0.5px solid #f7f7f7; //白边
          }
        }
      }
    }
  }
}
.page-plp_filter__list {
  .selected-box {
    padding-top: 52px;
    .selected-container {
      padding: 16px 0px;
      display: flex;
      flex-wrap: wrap;
      .gt-button {
        margin: 0px 6px 8px 0px;
        padding: 0px 8px 0px 12px;
        height: 32px;
        line-height: 1.1;
      }
    }
  }

  .el-collapse-item__header {
    line-height: 64px;
    height: 64px;
    color: var(--secondary-color-ua-cool-grey-04, #50505a);
    font-size: 14px;
    border-bottom: 1px #eeeeee solid !important;
    letter-spacing: 1.5px;
    font-weight: 400;
    .el-collapse-item__arrow {
      color: var(--font-color-primary);
    }
    // .el-collapse-item__arrow.is-active {
    //   transform: rotate(90deg);
    // }
  }
  .is-active {
    .el-collapse-item__header {
      color: #282832;
    }
  }
  .el-collapse-item__content {
    padding: 20px 28px 20px 0;
  }
  .size-collapse-item {
    .el-collapse-item__content {
      padding-right: 0px;
    }
  }

  .gt-checkbox {
    color: var(--font-color-primary);
    display: block;
    margin-bottom: 16px;
    line-height: 14px;
    &:last-child {
      margin-bottom: 0px;
    }
    .el-checkbox__inner {
      border: 1px solid var(--font-color-secondary);
      border-radius: 1px;
    }
    .el-checkbox__label {
      color: var(--main-color-ua-dark-grey, #14141e);
      font-weight: normal;
      padding-left: 12px;
      margin-left: 0px;
    }
  }
  .category-name {
    margin: 16px 0px;
    font-size: 14px;
    color: var(--secondary-color-ua-cool-grey-05, #282832);
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    &:first-child {
      margin-top: 0px;
    }
  }
}
.plp-filter_drawer {
  .el-drawer__header {
    display: none;
  }
  .el-drawer__body {
    padding: 20px 0px 20px 24px;
    position: relative;
    padding-bottom: 80px;
    .page-plp_filter__list {
      height: 100%;
      overflow-y: scroll;
      padding-right: 24px;
      .color-list {
        width: 206px;
      }
    }
    .selected-box {
      padding-top: 0px;
      .selected-title {
        width: calc(50% + 16px);
        justify-content: space-between;
        flex-direction: row-reverse;
        margin-bottom: 20px;
      }
    }
    .selected-container {
      padding: 0px 0px 12px;
    }

    .drawer-bottom {
      background: #fff;
      z-index: 1;
      position: absolute;
      left: 0px;
      right: 0px;
      bottom: 0px;
      padding: 16px 24px;
    }
  }
}
</style>
